<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-button type="primary" icon="plus" @click="addTemplate" style="width: 100%" >添加产品</el-button>
      </el-col>

    </el-row>


    <el-table :data="tagsList" :height="wheight-130" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100"></el-table-column>
      <el-table-column prop="name" label="产品名称" width="250">
        <template slot-scope="scope">
          {{scope.row.name}}
      </template>
      </el-table-column>
      <el-table-column prop="url" label="产品地址" width="250">
        <template slot-scope="scope">
          {{scope.row.url}}
        </template>
      </el-table-column>

      <el-table-column prop="url" label="图片地址" width="250">
        <template slot-scope="scope">
<!--          {{scope.row.pic_url}}-->
          <el-image  :src="scope.row.pic_url" style="width: 100px;height: 60px" mode="modeWidth"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="time" label="创建时间" width="250">
        <template slot-scope="scope">
          {{scope.row.time}}
        </template>
      </el-table-column>

      <el-table-column prop="company" label="保险公司" width="250">
        <template slot-scope="scope">
          {{scope.row.company}}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div class="operating-icons">
            <i class="iconfont icon-edit1" @click="editAction(scope.$index, scope.row)"></i>
            <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="total_count > params.page_size" class="content-center content-top-padded">
     <el-pagination
     layout="prev, pager, next"
     @current-change="handleCurrentChange"
     :current-page.sync="params.page"
     :total="total_count" :page-size="params.page_size">
     </el-pagination>
   </div>
   <el-dialog title="添加、编辑标签" width="40%" :visible.sync="memberTagDialog" :before-close="handleCancelLabelsDialog">
     <template>
       <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
         <el-form-item class="content-left" label="产品名称">

           <el-input placeholder="请输入产品名称" v-model="form.name"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="产品地址">

           <el-input placeholder="请输入产品地址" v-model="form.url"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="保险公司">

           <el-input placeholder="请输入保险公司" v-model="form.company"></el-input>
         </el-form-item>
         <el-form-item class="content-left" label="图片地址">

           <el-input placeholder="请输入图片地址" v-model="form.pic_url"></el-input>
         </el-form-item>
<!--         <el-form-item class="content-left" label="图片地址">-->

<!--           <el-input placeholder="请输入图片地址" v-model="form.pic_url"></el-input>-->
<!--         </el-form-item>-->

         <el-upload
           class="upload-demo"
           :multiple="true"
           :action="actionPath"
           accept="image/jpeg,image/png,image/gif"
           :show-file-list="false"
           :data="postData"
           :before-upload="beforeAvatarUpload"

           :on-success="handleAvatarSuccess"
         >
           <el-button type="primary">本地上传</el-button>
           <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
         </el-upload>
         <el-form-item class="content-center">
           <el-button type="primary" @click="saveTagData">确定保存</el-button>
         </el-form-item>
       </el-form>
     </template>
   </el-dialog>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { Message } from 'element-ui'
  import { getInstanceList,save,del,edit } from'../../../api/commercial_insurance.js'
  import {getUploadQiniuPicToken, uploadQiniuPic} from "../../../api/qiniu";
  export default {
    data () {
      return {
        isEdit: false,
        tagsList: [],
        loading: false,
        total_count: 0,
        actionPath: 'https://up-z1.qiniup.com',
        image_prefix: '',

        postData: {
          token: '',
          key: '',
          fname: ''
        },
        pic_url:'',
        tag: [
          {label: '普药', value: 0},
          {label: '慢病', value: 1},
          {label: '慢病+', value: 2},
          {label: '肿瘤', value: 3}
        ]
      ,
        params: {
          page: 1,
          pageSize: 20,
          product_name: '',
        },
        form: {
          tag_id: '',
          product_name: '',
          tag_color: '#ff1939',
          font_color: '#ffffff',
          description: '',
          front_show: '0',
        },
        memberTagDialog: false,
        predefineColors:['#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585']
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {

      beforeAvatarUpload(file) {

        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isGIF = file.type === 'image/gif';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG && !isPNG && !isGIF) {
          this.$message.error('上传图片只能是 JPG 或者 PNG 格式!')
          return
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
          return
        }

        this.postData.fname = file.name

        let tokenParams = { filename: file.name, filesystem: 'qiniu' }
        return getUploadQiniuPicToken(tokenParams).then(response => {
          this.postData.token = response.data.data.token
          this.postData.key = response.data.data.key
          this.image_prefix = response.data.data.domain
          this.pic_url= response.data.data.domain+response.data.data.key

        })
      },
      handleAvatarSuccess(res, file) {

        let uploadParams = {
          image_cat_id: 2,    //图片分类必填,必须为整数
          image_name: file.name,   //图片名称必填,不能超过50个字符
          image_url: res.key,    //图片链接必填
          // image_full_url: res.height,   //图片完整链接必填
          image_type: file.raw.type,   //图片分类长度不能超过20个字符
          storage: 'qiniu',   //图片id必填
        }


        uploadQiniuPic(uploadParams).then(res => {

          this.$message({
            message: '上传成功',
            type: 'success',
            duration: 5 * 1000
          })
          this.isLoadData = false
        })
        // }
      },
      handleCurrentChange (page_num) {
        this.params.page = page_num
        this.getDataList()
      },
      addTemplate () { // 添加商品
        this.memberTagDialog = true
        this.form = {id: '',product_name: '',tag: ''}
      },
      editAction (index, row) { // 编辑商品弹框
        this.form = row
        this.memberTagDialog = true
      },
      preview (index, row) { // 预览弹框
        this.dialogVisible = true
        this.dataInfo = row
      },
      searchData () {
        this.params.page = 1
        this.getDataList()
      },
      getDataList () {
        this.loading = true
        getInstanceList(this.params).then(response => {
          this.tagsList = response.data.data.list
          this.total_count = response.data.data.total_count
          this.loading = false
        }).catch(error => {
          this.loading = false
          this.$message({
            type: 'error',
            message: '获取列表信息出错'
          })
        })
      },
      deleteAction (index, row) {
        this.$confirm('此操作将删除数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          del(row.id).then(response => {

            this.$message({
              message: '删除成功',
              type: 'success',
              duration: 5 * 1000
            })
            this.getDataList()
          }).catch(() => {
            this.$message({
              type: 'error',
              message: '删除失败'
            })
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      getTaskTime (strDate) {
          let date = new Date(strDate)
          let y = date.getFullYear()
          let m = date.getMonth() + 1
          m = m < 10 ? ('0' + m) : m
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          let str = y+"-"+m+"-"+d
          return str
      },
      getTimeStr (date) {
        return this.getTaskTime(new Date(parseInt(date) * 1000))
      },
      handleCancelLabelsDialog () {
  			this.memberTagDialog = false
      },
      saveTagData () {
        this.memberTagDialog = false

        if (this.form.id) {

          edit(this.form.id, this.form).then(res => {

            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        } else {
          this.form.pic_url= this.pic_url
          save(this.form).then(res => {
            if (res.data.data) {
              this.$message({
                type: 'success',
                message: '保存成功'
              })
              this.getDataList()
            }
          })
        }
      }
    },
    mounted () {
      this.getDataList()
    }
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// insurance.vue?178cd789